import LoadingMenuPage from './LoadingMenuPage';
import LoadingTablePage from './LoadingTablePage';

export default {
  LoadingMenuPage,
  LoadingTablePage,
};
